export const logoShader = `
precision highp float;
uniform vec2 resolution;
uniform vec2 offset;
uniform float time;
uniform float enterTime;
uniform sampler2D src;

uniform float delay;
#define speed 1.5

float nn(float y, float t) {
    float n = (
        sin(y * .07 + t * 8. + sin(y * .5 + t * 10.)) +
        sin(y * .7 + t * 2. + sin(y * .3 + t * 8.)) * .7 +
        sin(y * 1.1 + t * 2.8) * .4
    );
    n += sin(y * 124. + t * 100.7) * sin(y * 877. - t * 38.8) * .3;
    return n;
}

vec4 readTex(sampler2D tex, vec2 uv) {
    if (uv.x < 0. || uv.x > 1. || uv.y < 0. || uv.y > 1.) { return vec4(0); }
    return texture2D(tex, uv);
}

vec4 glitch(vec2 uv) {
    vec2 uvr = uv, uvg = uv, uvb = uv;
    float t = mod(time, 30.);
    float amp = 10. / resolution.x;
    if (abs(nn(uv.y, t)) > 1.) {
        uvr.x += nn(uv.y, t) * amp;
        uvg.x += nn(uv.y, t + 10.) * amp;
        uvb.x += nn(uv.y, t + 20.) * amp;
    }
    vec4 cr = readTex(src, uvr);
    vec4 cg = readTex(src, uvg);
    vec4 cb = readTex(src, uvb);

    return vec4(
        cr.r,
        cg.g,
        cb.b,
        smoothstep(.0, 1., cr.a + cg.a + cb.a)
    );
}
vec4 slitscan(vec2 uv) {
    float t = max(enterTime - delay, 0.) * speed;
    if (t <= 0.0) {
        return vec4(0);
    }

    vec2 uvr = uv, uvg = uv, uvb = uv;
    uvr.x = min(uvr.x, t);
    uvg.x = min(uvg.x, max(t - 0.2, 0.));
    uvb.x = min(uvb.x, max(t - 0.4, 0.));

    vec4 cr = readTex(src, uvr);
    vec4 cg = readTex(src, uvg);
    vec4 cb = readTex(src, uvb);

    return vec4(
        cr.r, cg.g, cb.b, (cr.a + cg.a + cb.a) / 1.
    );
}

void main (void) {
    vec2 uv = (gl_FragCoord.xy - offset) / resolution;
    if (enterTime < 1.0) {
        gl_FragColor = slitscan(uv);
    } else {
        gl_FragColor = glitch(uv);
    }
}
`
